// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modern CSS Reset */

/* 1. Use a more-intuitive box-sizing model */
*,
*::before,
*::after {
  box-sizing: border-box;
}

/* 2. Remove default margin */
* {
  margin: 0;
}

/* 3. Enable keyword animations */
@media (prefers-reduced-motion: no-preference) {
  html {
    interpolate-size: allow-keywords;
  }
}

body {
  /* 4. Add accessible line-height */
  line-height: 1.5;
  /* 5. Improve text rendering */
  -webkit-font-smoothing: antialiased;
}

/* 6. Improve media defaults */
img,
picture,
video,
canvas,
svg {
  display: block;
  max-width: 100%;
}

/* 7. Inherit fonts for form controls */
input,
button,
textarea,
select {
  font: inherit;
}

/* 8. Avoid text overflows */
p,
h1,
h2,
h3,
h4,
h5,
h6 {
  overflow-wrap: break-word;
}

/* 9. Improve line wrapping */
p {
  text-wrap: pretty;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  text-wrap: balance;
}

/*
  10. Create a root stacking context
*/
#root,
#__next {
  isolation: isolate;
}

/* Custom CSS Rules */

:root {
  /* Background gradients */
  --gradient-start: #3572e0;
  --gradient-end: #9445f0;

  /* Base overlays */
  --overlay-weak: hsla(0, 0%, 100%, 0.12);
  --overlay-medium: hsla(0, 0%, 100%, 0.26);
  --overlay-strong: hsla(0, 0%, 100%, 0.45);

  /* Cards */
  --card-bg: rgba(255, 255, 255, 0.15);
  --card-bg-hover: var(--overlay-weak);

  /* Text */
  --text-color: #ffffff;

  /* Inputs */
  --input-focus: var(--overlay-weak);

  /* Buttons */
  --btn-submit: #3a86ff;
  --btn-submit-hover: var(--overlay-medium);

  /* Slider / toggle */
  --slider-bg: var(--overlay-strong);
  --slider-checked: var(--overlay-medium);

  /* Base font size */
  --font-lg: 1.25rem; /* 20px - emphasis */
  --font-xl: 1.5rem; /* 24px - headings */
  --font-xxl: 2rem; /* 32px - big numbers like temperature */

    /* Extra large for weather app */
  --font-hero: 2.5rem;  /* 40px - key headings/conditions */
  --font-display: 5.25rem; /* 84px - main temperature */
}

html {
  height: 110vh;
}

body {
  display: grid;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding-top: 3.25rem;
  font-size: 1.125rem;
  color: var(--text-color);
  background: linear-gradient(
    135deg,
    var(--gradient-start),
    var(--gradient-end)
  );
}

/* Layout */

.form {
  display: flex;
  gap: 1.25rem;
}

/* Search Bar */
.input-search {
  flex: 1;
  border: none;
  border-radius: 1.5rem;
  padding: 0 1rem 0 1rem;
  font-size: var(--font-lg);
  color: var(--text-color);
  backdrop-filter: blur(20px);
  background-color: var(--card-bg);
  transition: all 0.35s ease;
}

.input-search:focus {
  outline: none;
  box-shadow:
    rgba(50, 50, 93, 0.25) 0px 13px 27px -5px,
    rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;
  background-color: var(--input-focus);
}

input::placeholder {
  color: hsla(0, 0%, 100%, 0.65);
}

.submit-btn {
  display: flex;
  border: none;
  border-radius: 50px;
  padding: 1rem;
  color: var(--text-color);
  background-color: var(--btn-submit);
  transition: all 0.3s ease;
}

.submit-btn:hover {
  background-color: var(--btn-submit-hover);
  cursor: pointer;
}

.submit-btn:active {
  transform: scale(0.8);
}

.temperature-scale {
  display: grid;
  grid-auto-flow: column;
  place-items: center;
  column-gap: 0.5rem;

  width: max-content;
  border-radius: 1.5rem;
  padding: 0.25rem 0.75rem;

  backdrop-filter: blur(20px);
  background-color: var(--card-bg);
}

/* Toggle Switch */

.switch {
  position: relative;
  display: inline-block;
  width: 3.5rem;
  height: 1.875rem;
}

/* Hide Default checkbox */
.switch input {
  width: 0;
  height: 0;
  opacity: 0;
}

/* The slider */
.slider {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  background-color: var(--slider-bg);
  -webkit-transition: 0.4s;
  transition: 0.4s;
  cursor: pointer;
}

.slider:before {
  position: absolute;
  content: '';
  left: 0.25rem;
  bottom: 0.25rem;

  height: 1.375rem;
  width: 1.375rem;

  background-color: var(--text-color);
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: var(--slider-checked);
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 1.5rem;
}

.slider.round:before {
  border-radius: 50%;
}

/* Weather Content */
.weather-card {
  display: grid;
  grid-template-rows: max-content 1fr;
  grid-template-columns: max-content max-content;
  gap: 1.25rem;
}

.error-msg {
  grid-area: 2 / 1 / 3 / 3;
  display: none;
}

.loading-container {
  grid-area: 2 / 1 / 3 / 3;
  display: none;
  justify-content: center;
  row-gap: 0.75rem;
  font-size: var(--font-xl);
}

/* Weather Overview */
.overview {
  grid-area: 2 / 1 / 3 / 3;
  display: grid;
  grid-template-areas:
    'location'
    'groups';
  row-gap: 1.25rem;
}

.location {
  grid-area: location;
  justify-self: center;
  font-size: var(--font-xxl);
}

.now-text {
  font-size: var(--font-xl);
  font-weight: 600;
}

.current-temp {
  margin-bottom: -8px;
  font-size: var(--font-hero);
}

.feels-like, .condition-status {
  font-size: var(--font-lg);
}

.condition-status-icon {
  font-size: var(--font-display);
}

.groups {
  grid-area: groups;
  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-items: center;
}

.overview-right {
  display: grid;
  justify-items: center;
}

.overview-left {
  display: grid;
  grid-template-rows: max-content max-content max-content;
}

/* Weather Details */

.details div div {
  display: grid;
  place-items: center;
  border-radius: 0.75rem;
  padding: 0.5rem;
  background-color: var(--card-bg);
  transition: all 0.3s ease;
}

.details div div:hover {
  box-shadow:
    rgba(0, 0, 0, 0.1) 0px 20px 25px -5px,
    rgba(0, 0, 0, 0.04) 0px 10px 10px -5px;
  background-color: var(--card-bg-hover);
  transform: translateY(-2px);
  cursor: pointer;
}

.details {
  grid-area: 3 / 1 / 4 / 3;
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 1rem;
}

.details-left,
.details-right {
  display: grid;
  row-gap: 1rem;
  padding: 1rem;
}

.details-left {
  padding-right: 0;
}

.details-right {
  padding-left: 0;
}

.details iconify-icon {
  font-size: var(--font-xxl);
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA,qBAAqB;;AAErB,6CAA6C;AAC7C;;;EAGE,sBAAsB;AACxB;;AAEA,6BAA6B;AAC7B;EACE,SAAS;AACX;;AAEA,iCAAiC;AACjC;EACE;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA,8BAA8B;AAC9B;;;;;EAKE,cAAc;EACd,eAAe;AACjB;;AAEA,uCAAuC;AACvC;;;;EAIE,aAAa;AACf;;AAEA,4BAA4B;AAC5B;;;;;;;EAOE,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE,iBAAiB;AACnB;AACA;;;;;;EAME,kBAAkB;AACpB;;AAEA;;CAEC;AACD;;EAEE,kBAAkB;AACpB;;AAEA,qBAAqB;;AAErB;EACE,yBAAyB;EACzB,yBAAyB;EACzB,uBAAuB;;EAEvB,kBAAkB;EAClB,uCAAuC;EACvC,yCAAyC;EACzC,yCAAyC;;EAEzC,UAAU;EACV,oCAAoC;EACpC,oCAAoC;;EAEpC,SAAS;EACT,qBAAqB;;EAErB,WAAW;EACX,kCAAkC;;EAElC,YAAY;EACZ,qBAAqB;EACrB,yCAAyC;;EAEzC,oBAAoB;EACpB,kCAAkC;EAClC,uCAAuC;;EAEvC,mBAAmB;EACnB,kBAAkB,EAAE,oBAAoB;EACxC,iBAAiB,EAAE,oBAAoB;EACvC,gBAAgB,EAAE,wCAAwC;;IAExD,gCAAgC;EAClC,mBAAmB,GAAG,mCAAmC;EACzD,uBAAuB,EAAE,4BAA4B;AACvD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,wBAAwB;EACxB;;;;GAIC;AACH;;AAEA,WAAW;;AAEX;EACE,aAAa;EACb,YAAY;AACd;;AAEA,eAAe;AACf;EACE,OAAO;EACP,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,2BAA2B;EAC3B,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb;;wCAEsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,wBAAwB;EACxB,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;;EAElB,kBAAkB;EAClB,qBAAqB;EACrB,wBAAwB;;EAExB,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA,kBAAkB;;AAElB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,QAAQ;EACR,SAAS;EACT,UAAU;AACZ;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;;EAET,kCAAkC;EAClC,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,eAAe;;EAEf,gBAAgB;EAChB,eAAe;;EAEf,mCAAmC;EACnC,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mCAAmC;EACnC,8CAA8C;EAC9C,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB;EACE,wBAAwB;EACxB,aAAa;EACb;;YAEU;EACV,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uDAAuD;AACzD;;AAEA,oBAAoB;;AAEpB;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE;;0CAEwC;EACxC,sCAAsC;EACtC,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,aAAa;EACb,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":["/* Modern CSS Reset */\n\n/* 1. Use a more-intuitive box-sizing model */\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n/* 2. Remove default margin */\n* {\n  margin: 0;\n}\n\n/* 3. Enable keyword animations */\n@media (prefers-reduced-motion: no-preference) {\n  html {\n    interpolate-size: allow-keywords;\n  }\n}\n\nbody {\n  /* 4. Add accessible line-height */\n  line-height: 1.5;\n  /* 5. Improve text rendering */\n  -webkit-font-smoothing: antialiased;\n}\n\n/* 6. Improve media defaults */\nimg,\npicture,\nvideo,\ncanvas,\nsvg {\n  display: block;\n  max-width: 100%;\n}\n\n/* 7. Inherit fonts for form controls */\ninput,\nbutton,\ntextarea,\nselect {\n  font: inherit;\n}\n\n/* 8. Avoid text overflows */\np,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  overflow-wrap: break-word;\n}\n\n/* 9. Improve line wrapping */\np {\n  text-wrap: pretty;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  text-wrap: balance;\n}\n\n/*\n  10. Create a root stacking context\n*/\n#root,\n#__next {\n  isolation: isolate;\n}\n\n/* Custom CSS Rules */\n\n:root {\n  /* Background gradients */\n  --gradient-start: #3572e0;\n  --gradient-end: #9445f0;\n\n  /* Base overlays */\n  --overlay-weak: hsla(0, 0%, 100%, 0.12);\n  --overlay-medium: hsla(0, 0%, 100%, 0.26);\n  --overlay-strong: hsla(0, 0%, 100%, 0.45);\n\n  /* Cards */\n  --card-bg: rgba(255, 255, 255, 0.15);\n  --card-bg-hover: var(--overlay-weak);\n\n  /* Text */\n  --text-color: #ffffff;\n\n  /* Inputs */\n  --input-focus: var(--overlay-weak);\n\n  /* Buttons */\n  --btn-submit: #3a86ff;\n  --btn-submit-hover: var(--overlay-medium);\n\n  /* Slider / toggle */\n  --slider-bg: var(--overlay-strong);\n  --slider-checked: var(--overlay-medium);\n\n  /* Base font size */\n  --font-lg: 1.25rem; /* 20px - emphasis */\n  --font-xl: 1.5rem; /* 24px - headings */\n  --font-xxl: 2rem; /* 32px - big numbers like temperature */\n\n    /* Extra large for weather app */\n  --font-hero: 2.5rem;  /* 40px - key headings/conditions */\n  --font-display: 5.25rem; /* 84px - main temperature */\n}\n\nhtml {\n  height: 110vh;\n}\n\nbody {\n  display: grid;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  padding-top: 3.25rem;\n  font-size: 1.125rem;\n  color: var(--text-color);\n  background: linear-gradient(\n    135deg,\n    var(--gradient-start),\n    var(--gradient-end)\n  );\n}\n\n/* Layout */\n\n.form {\n  display: flex;\n  gap: 1.25rem;\n}\n\n/* Search Bar */\n.input-search {\n  flex: 1;\n  border: none;\n  border-radius: 1.5rem;\n  padding: 0 1rem 0 1rem;\n  font-size: var(--font-lg);\n  color: var(--text-color);\n  backdrop-filter: blur(20px);\n  background-color: var(--card-bg);\n  transition: all 0.35s ease;\n}\n\n.input-search:focus {\n  outline: none;\n  box-shadow:\n    rgba(50, 50, 93, 0.25) 0px 13px 27px -5px,\n    rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;\n  background-color: var(--input-focus);\n}\n\ninput::placeholder {\n  color: hsla(0, 0%, 100%, 0.65);\n}\n\n.submit-btn {\n  display: flex;\n  border: none;\n  border-radius: 50px;\n  padding: 1rem;\n  color: var(--text-color);\n  background-color: var(--btn-submit);\n  transition: all 0.3s ease;\n}\n\n.submit-btn:hover {\n  background-color: var(--btn-submit-hover);\n  cursor: pointer;\n}\n\n.submit-btn:active {\n  transform: scale(0.8);\n}\n\n.temperature-scale {\n  display: grid;\n  grid-auto-flow: column;\n  place-items: center;\n  column-gap: 0.5rem;\n\n  width: max-content;\n  border-radius: 1.5rem;\n  padding: 0.25rem 0.75rem;\n\n  backdrop-filter: blur(20px);\n  background-color: var(--card-bg);\n}\n\n/* Toggle Switch */\n\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 3.5rem;\n  height: 1.875rem;\n}\n\n/* Hide Default checkbox */\n.switch input {\n  width: 0;\n  height: 0;\n  opacity: 0;\n}\n\n/* The slider */\n.slider {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n\n  background-color: var(--slider-bg);\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n  cursor: pointer;\n}\n\n.slider:before {\n  position: absolute;\n  content: '';\n  left: 0.25rem;\n  bottom: 0.25rem;\n\n  height: 1.375rem;\n  width: 1.375rem;\n\n  background-color: var(--text-color);\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n}\n\ninput:checked + .slider {\n  background-color: var(--slider-checked);\n}\n\ninput:checked + .slider:before {\n  -webkit-transform: translateX(26px);\n  -ms-transform: translateX(26px);\n  transform: translateX(26px);\n}\n\n/* Rounded sliders */\n.slider.round {\n  border-radius: 1.5rem;\n}\n\n.slider.round:before {\n  border-radius: 50%;\n}\n\n/* Weather Content */\n.weather-card {\n  display: grid;\n  grid-template-rows: max-content 1fr;\n  grid-template-columns: max-content max-content;\n  gap: 1.25rem;\n}\n\n.error-msg {\n  grid-area: 2 / 1 / 3 / 3;\n  display: none;\n}\n\n.loading-container {\n  grid-area: 2 / 1 / 3 / 3;\n  display: none;\n  justify-content: center;\n  row-gap: 0.75rem;\n  font-size: var(--font-xl);\n}\n\n/* Weather Overview */\n.overview {\n  grid-area: 2 / 1 / 3 / 3;\n  display: grid;\n  grid-template-areas:\n    'location'\n    'groups';\n  row-gap: 1.25rem;\n}\n\n.location {\n  grid-area: location;\n  justify-self: center;\n  font-size: var(--font-xxl);\n}\n\n.now-text {\n  font-size: var(--font-xl);\n  font-weight: 600;\n}\n\n.current-temp {\n  margin-bottom: -8px;\n  font-size: var(--font-hero);\n}\n\n.feels-like, .condition-status {\n  font-size: var(--font-lg);\n}\n\n.condition-status-icon {\n  font-size: var(--font-display);\n}\n\n.groups {\n  grid-area: groups;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  justify-items: center;\n}\n\n.overview-right {\n  display: grid;\n  justify-items: center;\n}\n\n.overview-left {\n  display: grid;\n  grid-template-rows: max-content max-content max-content;\n}\n\n/* Weather Details */\n\n.details div div {\n  display: grid;\n  place-items: center;\n  border-radius: 0.75rem;\n  padding: 0.5rem;\n  background-color: var(--card-bg);\n  transition: all 0.3s ease;\n}\n\n.details div div:hover {\n  box-shadow:\n    rgba(0, 0, 0, 0.1) 0px 20px 25px -5px,\n    rgba(0, 0, 0, 0.04) 0px 10px 10px -5px;\n  background-color: var(--card-bg-hover);\n  transform: translateY(-2px);\n  cursor: pointer;\n}\n\n.details {\n  grid-area: 3 / 1 / 4 / 3;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  column-gap: 1rem;\n}\n\n.details-left,\n.details-right {\n  display: grid;\n  row-gap: 1rem;\n  padding: 1rem;\n}\n\n.details-left {\n  padding-right: 0;\n}\n\n.details-right {\n  padding-left: 0;\n}\n\n.details iconify-icon {\n  font-size: var(--font-xxl);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
